import React from 'react';
import * as qs from 'query-string';
import Estado from '../modals/Estado';
import SolExcep from '../modals/SolicitudExcepcional';
import Lafit from '../modals/Lafit';
import AgregarEquipos from '../modals/AgregarEquiposAdicionales';
import DesasignarPedido from '../modals/DesasignarPedido';
import SolicitarFacturacion from '../modals/SolicitarFacturacion';
import NuevaFichaVenta from '../modals/NuevaFichaVenta';
import AsignarProformas from '../modals/AsignarProformas';
import CambiarCliente from '../modals/CambiarCliente';

import ErrorUIComponent from '../../utils/ErrorUIComponent';

function showModal(modalName, that) {

    switch (modalName) {
    case 'nueva-fdv':
      return (
        <ErrorUIComponent>
          <NuevaFichaVenta
            querys={qs.parse(that.props.location.search)}
            loading={that.loading}
            closeModal={that.closeModal}
          />
        </ErrorUIComponent>
      );
    case 'cambiarCliente':

    return (
      <CambiarCliente
      querys={qs.parse(that.props.location.search)}
      closeModal={that.closeModal}
      fichasVenta={that.props.fichasVenta.fichaVentaResponse[0]}
      fetchFichasVenta={that.props.fetchFichasVenta}
      />
    );

    case 'nueva-proforma':
      return (
        <AsignarProformas
          fdv={that.props.fichasVenta.fichaVentaResponse[0]}
          closeModal={that.closeModal}
        />
      );
    case 'Estado':
      return (
        <Estado
          fetchFichaVenta={that.props.fetchFichaVenta}
          estados={that.props.estados}
          closeModal={that.closeModal}
          openAlert={that.openAlert}
          fdvID={that.props.match.params.id}
        />
      );
    case 'SolExcep':
      return (
        <SolExcep
          closeModal={that.closeModal}
          tipos={that.props.excepcionales}
          fetchResponsables={that.props.fetchResponsables}
          responsables={that.props.responsables}
          fdvID={that.props.match.params.id}
          fichaVenta={that.props.fichasVenta.fichaVentaResponse[0]}
          openAlert={that.openAlert}
          fetchAutorizacionesExcepcionales={that.props.fetchAutorizacionesExcepcionales}
        />
      );
    case 'Lafit':
      return (
        <Lafit
          closeModal={that.closeModal}
          openAlert={that.openAlert}
          fdvID={that.props.match.params.id}
        />
      );
    case 'AgregarEquipos':
      return (
        <AgregarEquipos
          closeModal={that.closeModal}
          pedidosEquiposAdicionales={that.state.pedidosEquiposAdicionales.map(function(entry) {return entry.numPedidoVeh})}
          eliminarEquiposAdicionales={that.eliminarEquiposAdicionales}
          clientInput={that.state.clientInput}
          searchOption={that.state.searchOption}
          onChangeInput={that.onChangeInput}
          search={that.search}
          proveedorEquposAdicionales={that.props.proveedorEquposAdicionales}
          tipoAdicional={that.state.tipoAdicional}
          handlePageClickEquiposEspeciales={that.handlePageClickEquiposEspeciales}
          searchProveedorEquiposAdicionales={that.searchProveedorEquiposAdicionales}
          facturacionListado={that.state.facturacionListado}
          fnSeleccionProveedorEquiposLogistica={that.fnSeleccionProveedorEquiposLogistica}
          equiposProveedorEquipoLogistica={that.state.equiposProveedorEquipoLogistica}
          proveedorEquipoLogistica={that.state.proveedorEquipoLogistica}
          proforma={that.state.proformaSeleccionadaTabEquipoLogistica}
          fdv={that.props.fichasVenta.fichaVentaResponse[0]}
          nurPedidos={that.state.pedidosEquiposAdicionales}

          tipoLlamadaEquiposAdicionales={that.state.tipoLlamadaEquiposAdicionales}
          fnFetchEquiposCortesia={that.loadPage}
          whereRunTabOrProf={'1'}
          pedidosConPermisosParaRealizarAcciones={that.state.pedidosXfichaVenta}

        />
      );
    case 'DesasignarPedido':
      return (
        <DesasignarPedido
          closeModal={that.closeModal}

        />
      );
    case 'SolicitarFacturacion':
      return (
        <SolicitarFacturacion
          closeModal={that.closeModal}
          pedidosConCheck={that.state.pedidosConCheck}
          idFichaVenta={that.state.idFichaVenta}
          pedidos={that.state.pedidosClienteFacturacion}
          facturacionListado={that.state.facturacionListado}
          getCliente={that.getCliente}
          loading = {that.loading}
          openAlert={that.openAlert}
          llamadaProformaOrTabProforma={1}
          facturacionListadoModal={that.state.facturacionListadoModal}
          fnListadoPedidosFacturacion={that.fnListadoPedidosFacturacion}
          listProformaOrTabProforma={that.props.listProformaOrTabProforma}
          whereRunTabOrProf={'1'}
          nurPedidos={that.state.facturacionListado}
        />
      );

    default:
      return null;
  }
}

export default showModal;



// WEBPACK FOOTER //
// ./src/pages/DetalleFichaVenta/showModal.js